import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import Page from '../../components/Page/Page';
import { ProductFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

export const RateProducts = withRouter(() => {
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [masters, setMasters] = useState({});
  const [totalcount, setTotalcount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterparams, setFilterparams] = useState({});
  const [loading, setLoading] = useState(false);

  function applysearch(searchtext) {
    setPage(0);
    setFilterparams({
      ...filterparams,
      searchtext,
    });
  }

  function onPageChange(nextPage) {
    setPage(nextPage);
  }

  async function onUpdatestatus(indexval, ischecked) {
    const bodycontent = {
      product_id: orders[indexval].id,
      status: ischecked,
    };
    await sendNetworkRequest('/admin/updatestoreproductstatus', {}, bodycontent, true);
    fetchallproducts(filterparams, page, rowsPerPage);
  }

  function onPageLimit(limit) {
    setPage(0);
    setRowsPerPage(limit);
  }

  function applyfilter(filtercontent) {
    setPage(0);
    setFilterparams({ ...filtercontent });
  }

  async function fetchallproducts(filtercontent = {}, pageNum = page, limitNum = rowsPerPage) {
    setLoading(true);
    try {
      const bodycontent = {
        ...filtercontent,
        page: pageNum * limitNum,
        limit: limitNum,
      };
      const products = await sendNetworkRequest('/admin/getstoreproductmaster', {}, bodycontent, true);
      const rows = Array.isArray(products?.module) ? products.module : [];
      setOrders(rows);
      setTotalcount(rows.length >= limitNum ? (pageNum + 1) * limitNum + 1 : pageNum * limitNum + rows.length);
    } catch (error) {
      setOrders([]);
      setTotalcount(0);
    } finally {
      setLoading(false);
    }
  }

  async function fetchmasters() {
    const commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {}, false);
    setMasters({
      commodity: commodities?.module || [],
    });
  }

  useEffect(() => {
    fetchmasters();
  }, []);

  useEffect(() => {
    fetchallproducts(filterparams, page, rowsPerPage);
  }, [page, rowsPerPage, filterparams]);

  return (
    <Page
      className={classes.root}
      title="Rate Products"
    >
      <Header />
      <ProductFilter masters={masters} onSearch={applysearch} onFilter={applyfilter} />
      <Results
        className={classes.results}
        orders={orders}
        loading={loading}
        totalcount={totalcount}
        page={page}
        rowsPerPage={rowsPerPage}
        onStatusupdate={onUpdatestatus}
        onPageChange={onPageChange}
        onPageLimit={onPageLimit}
      />
    </Page>
  );
});

export default RateProducts;
